import script from "./FlashMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashMessage.vue?vue&type=script&setup=true&lang=js"

import "./FlashMessage.vue?vue&type=style&index=0&id=6ceaf78c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ceaf78c"]])

export default __exports__